/** Remove conversation-entry state without dropping unrelated integration parameters. */
export function freshConversationParams(params: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(params);
  for (const key of ['share', 'session', 'q']) next.delete(key);
  return next;
}
